module.exports = __webpack_public_path__ + "static/media/Ariadne.942d43ef.jpg";